import { ExposureAgentsService } from './exposure-agents.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exposure-agents',
  templateUrl: './exposure-agents.component.html',
  styleUrls: ['./exposure-agents.component.scss'],
})
export class ExposureAgentsComponent implements OnInit {
  agents: any[] = [];
  constructor(private agentsService: ExposureAgentsService) { }

  ngOnInit(): void {
    this.agentsService.agents.subscribe((agents) => (this.agents = agents));
  }
}
